import { QueryClient } from '@tanstack/react-query';

// Phase 6.A — TanStack Query staleTime = 60s (사용자 결정 #8).
// Phase 6.B-3-redo hotfix — `refetchOnMount: 'always'` 로 SPA navigation 회귀 방지.
// 같은 queryKey 를 다른 라우트가 공유할 때, 이전 라우트가 남긴 cache 가 stale 한
// 상태로 표시된 다음 마운트 시점에 refetch 가 보장되어야 사용자가 "0 으로 보임 →
// 새로고침으로 정상" 같은 회귀를 겪지 않는다.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});
